import React from 'react';
import { Alert, Button } from 'react-bootstrap';
import { useOutletContext } from 'react-router-dom';

function VendorW9() {
  const { w9 } = useOutletContext();

  if (!w9) return null;

  return (
    <div className="px-4 py-3 mb-1" style={{ marginInline: '-24px' }}>
      <h5 className="mb-3">W9</h5>
      <Alert
        className="w-100 d-flex flex-column flex-sm-row gap-3 align-items-sm-center justify-content-between"
        variant="info"
      >
        <span>Vendor has a W9 saved</span>

        <Button as="a" href={w9} target="_blank" rel="noreferrer" download>
          Download
        </Button>
      </Alert>
    </div>
  );
}

export default VendorW9;
